import { render, staticRenderFns } from "./OrderPaymentModal.vue?vue&type=template&id=34f4685f&"
import script from "./OrderPaymentModal.vue?vue&type=script&lang=js&"
export * from "./OrderPaymentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports